import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from 'src/libs/angular/core/src/lib/environments/environment';

@Component({
  selector: 'aa-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  customerAppURLBase = environment.customerAppURL;
}
